<template>
  <v-container if="">
        <v-list outlined style="min-height: 45vh; padding: 0px 10px;" v-show="list.length">
          <v-list-item-group  v-model="selectedNotification"  color="accent">
          <v-list-item two-line v-for="item in list" v-bind:key="item.id" style="border-bottom: 1px solid rgb(226 220 220); margin: 0 0 -1px 0; min-height: 52px;">
            <v-chip x-small color="accent" class="align-self-start mt-4 mr-2" v-if="!item.is_readed">Nova</v-chip>
            <v-list-item-content style="padding: 10px 0;">
              <v-list-item-title style="color:rgba(0, 0, 0, 0.87) !important">
                <v-tooltip bottom v-if="item.prioridade_alta">
                  <template v-slot:activator="{ on }">
                    <v-icon color="warning" small v-on="on" class="mr-1">fa-bookmark</v-icon>
                  </template>
                  <span
                    style="border: 1px solid #D8DDE6 !important; border-radius: 4px"
                    class="py-1 px-3"
                  >Alta importância</span>
                </v-tooltip>{{item.nome}}
              </v-list-item-title>
              <v-list-item-subtitle>{{modulosTitles[item.modulo]}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="align-self-start" style="color:rgba(0, 0, 0, 0.87) !important; margin: 10px 0;">
              <span>{{item.data_publicacao | formatDate}}</span>
            </v-list-item-action> <br>
          </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-col class="text-center py-0" cols="12">
          <v-pagination
            v-if="list.length>0"
            class="no-box-shadow"
            v-model="pagination.offset"
            :length="pagination.total_pages"
            @input="getList(pagination.offset)"
          ></v-pagination>
        </v-col>
        <p v-show="!list.length">Não há notificações para a busca realizada</p>
  </v-container>
</template>

<script>
import moment from 'moment'
moment.locale('pt-BR')
export default {
  components: {
  },
  data() {
    return { 
      selectedNotification: null
    };
  },
  filters:{
    formatDate(date) {
      return moment(date).format('L');
    }
  },
  watch: {
    selectedNotification(val, ind){
      if (val == undefined) {
        this.selectedNotification = ind
        this.selectItem(this.list[ind])
      } else {
        this.selectItem(this.list[val], true)
      }
      this.$nextTick()
    },
    list(){
      if(this.$store.state.notifications.dashNotification){
          this.selectedNotification = this.list.findIndex(item => item.id == this.$store.state.notifications.dashNotification)
          this.selectItem(this.list[this.selectedNotification])
          this.$store.commit("notifications/selectDashboardNotification", null);
        } else {
          this.selectItem(this.list[0])
        }
    }
  },
  props: {
    list: Array,
    modulosTitles: Object,
    selectItem: Function,
    getList: Function,
    pagination: Object
  },
};
</script>

<style>
</style>
